import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'hillsDate'
})
export class HillsDatePipe implements PipeTransform {

    transform(value: Date | string,
        includeTime: boolean = false,
        includeSeconds: boolean = false,
        nullAsEmpty = false,
        nullEmptyString = ''): any {
        if (nullAsEmpty && value == null) {
            return nullEmptyString;
        }

        const date = value instanceof Date ? value : new Date(value);
        return new DatePipe('en-NZ').transform(date, 'dd-MMM-yyyy'.concat(includeTime ? ' hh:mm'.concat(includeSeconds ? ':ss' : '') : ''));
    }

}
